import './SectionBar.css';

import React, { useContext } from 'react';
import { SharedVariableContext } from '../../App';

export default function SectionBar()
{
    //récupération des variables
    const { typeDePage, selectedOption } = useContext(SharedVariableContext);

    // Objet contenant les traductions pour chaque type de page
    const translations = {
        Accueil: {
            fr: 'Accueil',
            en: 'Home',
            es: 'Inicio',
            de: 'Startseite',
            uk: 'Home' // Alias pour en
        },
        Sommaire: {
            fr: 'Sommaire',
            en: 'Summary',
            es: 'Resumen',
            de: 'Inhaltsverzeichnis',
            uk: 'Summary' // Alias pour en
        },
        Nouveautés: {
            fr: 'Nouveautés',
            en: 'News',
            es: 'Novedades',
            de: 'Neuigkeiten',
            uk: 'News' // Alias pour en
        },
        Test: {
            fr: 'Test',
            en: 'Review',
            es: 'Reseña',
            de: 'Testbericht',
            uk: 'Review' // Alias pour en
        }
    };

    // Extraire la langue depuis selectedOption.value
    const language = selectedOption?.value || 'fr'; // Langue par défaut : fr

    // Récupérer la traduction
    const translatedTitle = translations[typeDePage]?.[language] || translations[typeDePage]?.en || typeDePage || 'Page non trouvée';

    // Pour le débogage
    console.log('typeDePage:', typeDePage);
    console.log('selectedOption:', selectedOption);
    console.log('language:', language);
    console.log('translatedTitle:', translatedTitle);

    // Pour le débogage
    console.log('typeDePage:', typeDePage);
    console.log('selectedOption:', selectedOption);
    console.log('language:', language);
    console.log('translatedTitle:', translatedTitle);

    return(
        <div id='SectionBar'>
            {translatedTitle}
        </div>

    )
}